import { configureStore } from "@reduxjs/toolkit";
import NewsSlice from "../features/news/NewsSlice";
import carouselSlice from "../features/carouselSlice/CarouselSlice";
import NoticeSlice from "../features/noticeSlice/NoticeSlice";
import staffSidebarReducer from "../features/staffSidebar/staffSidebarSlice";
import authReducer from "../features/auth/authSllice";
import branchSlice from "../features/branch/branchSlice";
import aboutSlice from "../features/aboutSlice/aboutSlice";
import userBlockSlice from "../features/userBlock/userBlockSlice";
import gallerySlice from "../features/gallerySlice/gallerySlice";
import testimonialsSlice from "../features/testimonials/testimonialsSlice";
import adSlice from "../features/adSlice/adSlice";
import downloadSlice from "../features/downloads/downloadSlice";

import permissionSlice from "../features/permissions/permissionSlice";
import serviceSlice from "../features/serviceDetailSlice/serviceSlice";
// import permissionSlice from "../features/permissions/permissionSlice";


export const store = configureStore({
  reducer: {
    news: NewsSlice,
    carousel: carouselSlice,
    notice: NoticeSlice,
    staffSidebar: staffSidebarReducer,
    auth: authReducer,
    branch: branchSlice,
    downloads: downloadSlice,
    about: aboutSlice,
    userBlock: userBlockSlice,
    gallery: gallerySlice,
    testimonials: testimonialsSlice,
    ad: adSlice,
    permissions: permissionSlice,
    bussiness: serviceSlice
    
    

  },
});
